import {
  transformerMetaHighlight,
  transformerMetaWordHighlight,
} from "@shikijs/transformers"
import { toHtml } from "hast-util-to-html"
import {
  bundledLanguages,
  type CodeToHastOptions,
  isSpecialLang,
  codeToHast as shiki_codeToHast,
  codeToHtml as shiki_codeToHtml,
} from "shiki"

// TODO: Fine-grained bundle
const sharedOptions = {
  lang: "plaintext",
  themes: {
    dark: "github-dark",
    light: "github-light",
  },
  transformers: [
    {
      name: "line-numbers",
      code(hast) {
        let lineCount = 0
        for (const child of hast.children) {
          if (child.type !== "text") continue
          if (child.value !== "\n") continue
          lineCount += 1
        }
        const properties = metaToLineNumbersProperties(
          this.options.meta?.__raw,
          { lineCount, style: "string" },
        )
        for (const [key, value] of Object.entries(properties)) {
          hast.properties[key] = value as (typeof hast.properties)[typeof key]
        }
      },
    },
    transformerMetaHighlight() as never,
    transformerMetaWordHighlight() as never,
  ],
} satisfies CodeToHastOptions

export function codeToHtml(options: {
  code: string
  lang: string
  meta: string | null | undefined
}) {
  const { code, lang, meta } = options
  if (lang && !isSpecialLang(lang) && !(lang in bundledLanguages))
    console.warn(`Unsupported language '${lang}'`)
  return shiki_codeToHtml(code.trim(), {
    ...sharedOptions,
    lang,
    ...(meta ? { meta: { __raw: meta } } : {}),
  })
}

export function codeToHast(options: { code: string; lang: string }) {
  const { code, lang } = options
  if (lang && !isSpecialLang(lang) && !(lang in bundledLanguages))
    console.warn(`Unsupported language '${lang}'`)
  return shiki_codeToHast(code, { ...sharedOptions, lang })
}

export function codeHastToHtml(
  hast: Awaited<ReturnType<typeof shiki_codeToHast>>,
) {
  return toHtml(hast)
}

export function metaToLineNumbersProperties(
  meta: string | null | undefined,
  opts: {
    lineCount: number
    style: "object" | "string"
  },
) {
  if (!meta?.includes("showLineNumbers")) return {}

  // s/o https://rehype-pretty.pages.dev for this part
  const lineNumbersStartAtMatch = meta
    .split("")
    .reverse()
    .join("")
    .match(/(?:\}(\d+){)?srebmuNeniLwohs(?!(.*)(\/))/)
  const startNumberString = lineNumbersStartAtMatch?.at(1)
  const startAt = startNumberString
    ? Number(startNumberString?.split("").reverse().join("")) - 1
    : 0
  const maxDigits = startAt + opts.lineCount
  const counterSet = `line ${startAt}`

  return {
    "data-line-numbers": true,
    "data-line-numbers-max-digits": maxDigits.toString().length,
    ...(startNumberString
      ? {
          style:
            opts.style === "object"
              ? { counterSet }
              : `counter-set: ${counterSet};`,
        }
      : {}),
  }
}
